if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.sliderWrapper = this.querySelector('.collection-list__items');
      this.sliderInstance = false;
      this.initSlider();
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object') return;

      const sliderOptions = {
        modules: [FoxTheme.Swiper.Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 8,
        loop: true,
        speed: 5500,
        allowTouchMove: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
          reverseDirection: true,
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
          },
        },
      };

      this.classList.add('swiper');
      this.sliderWrapper.classList.remove('f-grid');
      this.sliderWrapper.classList.add('swiper-wrapper');
      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          if (event.detail.sectionId !== this.sectionId) return;
          const index = Number(event.target.dataset.index);
          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }
  }

  customElements.define('collection-list', CollectionList);
}
